// extracted by mini-css-extract-plugin
module.exports = {"form":"ProfileForm_form__2xGgc","control":"ProfileForm_control__2YUZH","action":"ProfileForm_action__opJ_6"};